/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HouseInputs */

const cs_enum_house = /** @type {(inputs: Enum_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dům`)
};

const en_enum_house = /** @type {(inputs: Enum_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House`)
};

/**
* | output |
* | --- |
* | "House" |
*
* @param {Enum_HouseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_house = /** @type {((inputs?: Enum_HouseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HouseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_house(inputs)
	return cs_enum_house(inputs)
});